import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionCheckService } from '../../core/services/version-check.service';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-outdated-version-banner',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './outdated-version-banner.component.html',
  styleUrls: ['./outdated-version-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OutdatedVersionBannerComponent {
  readonly outdated$ = this._versionCheck.outdated$;

  constructor(private _versionCheck: VersionCheckService) { }

  reload(): void {
    window.location.reload();
  }
}
